module.exports = __webpack_public_path__ + "static/media/ServiceSTC.039d92ae.jpg";